import { useEffect, useState } from 'react';

import { Modal, TextField } from '@atom/mui';

const styles = {
  iconLayoutDiv: { display: 'flex', alignItems: 'center', gap: '1rem' },
};

export interface Props {
  open: boolean;
  initialValue: string;
  loading?: boolean;
  title?: string;
  fieldName?: string;
  cancelText?: string;
  confirmText?: string;
  icon?: string;
  onCancel: () => void;
  onConfirm: (value: string) => void;
}

const EditModal = ({
  open,
  loading,
  title = 'Edit',
  onCancel,
  onConfirm,
  cancelText = 'Cancel',
  confirmText = 'Save',
  initialValue,
  fieldName,
  icon,
}: Props) => {
  const [value, setValue] = useState<string>(initialValue);

  const setErrorText = () => {
    return value?.length === 0 ? `The ${fieldName} name cannot be blank` : '';
  };

  const disabled = loading || value?.length === 0;

  useEffect(() => {
    if (!open) {
      setValue(initialValue);
    }
  }, [open, initialValue]);

  return (
    <Modal
      title={title}
      open={open}
      loading={loading}
      disabled={disabled}
      cancelButtonText={cancelText}
      onCancel={onCancel}
      confirmButtonText={confirmText}
      onConfirm={() => onConfirm(value)}
    >
      <div style={styles.iconLayoutDiv}>
        {icon && (
          <div>
            <img src={icon} />
          </div>
        )}
        <TextField
          label={fieldName || ''}
          value={value}
          name="value"
          error={setErrorText().length > 0}
          helperText={setErrorText()}
          onChange={event => setValue(event.target.value)}
        />
      </div>
    </Modal>
  );
};

export default EditModal;
